<template>
<div class="comment-pop" >
                <Popover placement="bottom-end" v-model="commentpop">
                  <div class="popover-primary">
                    <div class="popover-primary-header">
                      <h3>Comments</h3>
                      <span class="remove-icon" @click="commentpop=false">
                        <svgicon name="cancel" width="10" height="10" :original="true" />
                      </span>
                    </div>
                    <div class="popover-primary-body">
                      <div class="timeline-comment">
                        <div v-if="commentLoading">Loading ....</div>
                        <div class="content"
                            v-for="comment in comments"
                            v-bind:key="comment._id">
                        <div class="content-item">
                         <div class="dot dot-indent"></div>
                        </div>
                        <div class="content-body" >
                          <div class="content-body-status">
                           <p class="content-item-title"> {{ (comment.user.name) ? comment.user.name : 'User' }} </p>
                           <p class="content-item-sec"> {{comment.create_at | moment("DD MMM YY | HH : mm A") }} </p>
                           <p class="content-item-primary"> {{comment.message}} </p>
                          </div>
                        </div>
                       </div>
                       <div v-if="!comments.length">No Comments</div>
                      </div>
                    </div>
                  </div>
                  <div slot="reference">
                    <svgicon name="Comment-mark" @click="$emit('getComments',orderId)" width="10" height="10" :original="true" />
                  </div>
                </Popover>
              </div>
</template>
<script>
export default {
  props: {
comments: {
  type:Array,
},
orderId: {
  type: String
},
commentLoading: {
  type: Boolean,
  default: false,
}
  },
  data() {
    return {
      commentpop: false,
    }
  }
}
</script>